import * as React from 'react'

import Box from '@mui/material/Box'
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

//icons
import StarBorder from '@mui/icons-material/StarBorder';
import Star from '@mui/icons-material/Star';
import Delete from '@mui/icons-material/Delete';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import PersonAddOutlinedIcon from '@mui/icons-material/PersonAddOutlined';

import { WorkAreaHandlers } from '../../WorkArea';

import UserAsset from "../../../../api/model/UserAsset";
import Asset from "../../../../api/model/Asset";
import AssetFav from "../../../../api/model/AssetFav";
import BackgroundFav from "../../../../api/model/BackgroundFav";
import AudioFav from "../../../../api/model/AudioFav";
import { DialogData } from '../dialogs/UploadAssetDialog';

import Editor from '../../../core/Editor';

import { WithTranslation, withTranslation } from 'react-i18next';
import { ACLResourceType } from '../../../../api/model/ACLResourceType';

const styles = {
  dropDown: {
    position: 'absolute' as 'absolute',
    top: 5,
    right: 5,
    background: 'rgb(66 66 66 / 80%)',
    borderRadius: '5px'
  },
  dropDownAudios: {
    position: 'absolute' as 'absolute',
    top: 5,
    right: 5
  },
  buttonDelete: {
    padding: '5px'
    }
};

interface State {
  optionsButtonEl: HTMLElement;
}

interface Props {
  editor: Editor;
  handlers: WorkAreaHandlers;
  handleDeleteAsset: (wideoId: string, assetId: string) => void,
  handleSelectAsset: (asset: Asset, audioScene: boolean) => void,
  handlePlayAsset: (ref: HTMLVideoElement | string, url: string, isPlaying: Boolean) => void,
  handleSaveAsFavAsset: (assetId: string) => void,
  handleDeleteAsFavAsset: (assetId: string) => void,
  assets: Asset[],
  isVideoAsset: boolean,
  isFavAsset: boolean,
  isSharedAsset: boolean,
  data: DialogData,
  assetFavKeyId: (assetFav: (AssetFav | BackgroundFav | AudioFav)) => void,
  assetFavIndex: () => string[],
  assetSharedKeyId: (assetShared: (Asset)) => void,
  assetSharedIndex: () => string[],
  handleOpenAddAudioDialog: (asset: Asset) => void
}

type Styled = any

type PropsWithStyles = Props & WithTranslation & Styled;

//type PropsWithStyles = Props & WithTranslation & WithStyles<'dropDown' | 'dropDownAudios' | 'buttonDelete'>;

class UploadAssetDialogActions extends React.PureComponent<PropsWithStyles, State> {

  constructor(props: PropsWithStyles) {
    super(props);
    this.state = {
      optionsButtonEl: null,
    }
  }

  handleOpenMenu = (event: React.SyntheticEvent<HTMLElement>) => {
    this.setState({ optionsButtonEl: event.currentTarget });
  };

  handleCloseMenu = () => {
    this.setState({ optionsButtonEl: null });
  };

  handleSaveAsFavAsset = (assetId: string) => {
    this.props.handleSaveAsFavAsset(assetId)
    this.handleCloseMenu()
  };

  handleDeleteAsFavAsset = (assetId: string) => {
    this.props.handleDeleteAsFavAsset(assetId)
    this.handleCloseMenu()
  };

  handleShareWithOpen = (ACLResourceIdSelected: string, ACLResourceTypeSelected: ACLResourceType) => {
    this.props.handlers.handleShareWithOpen(ACLResourceIdSelected, ACLResourceTypeSelected);
    this.handleCloseMenu()
  };

  handleDeleteAsset = (assetwideoId: string, assetId: string) => {
    this.props.handleDeleteAsset(assetwideoId, assetId)
    this.handleCloseMenu()
  };


  getFavAssetIcon = (asset: (Asset | UserAsset)) => {
    const { t } = this.props;

    const assetFavIndex: number = this.props.assetFavIndex().indexOf(asset.id, 0)

    return assetFavIndex !== -1 ? (
      <MenuItem
        button
        dense
        onClick={() => { this.handleDeleteAsFavAsset(asset.id) }}
        cyclass="favAssetIconOn"
      >
        <ListItemIcon>
          <Star fontSize="small" />
        </ListItemIcon>
        <ListItemText primary={t("leftbar.commons.delete-as-fav")} />
      </MenuItem>
    ) : (
        <MenuItem
          button
          dense
          onClick={() => { this.handleSaveAsFavAsset(asset.id) }}
          cyclass="favAssetIconOff"
        >
          <ListItemIcon>
            <StarBorder fontSize="small" />
          </ListItemIcon>
          <ListItemText primary={t("leftbar.commons.add-as-fav")} />
        </MenuItem>
      )
  }

  getSharedAssetIcon = (asset: (UserAsset)) => {
    const { t } = this.props;
    return (
      <MenuItem
        button
        dense
        onClick={() => { this.handleShareWithOpen(asset.id, asset.getACLResourceType()) }}
        cyclass="sharedAssetIconOff"
      >
        <ListItemIcon>
          <PersonAddOutlinedIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText primary={t("leftbar.commons.add-as-shared")} />
      </MenuItem>
    )
  }

  getItemsActions = (asset: (Asset | UserAsset)): JSX.Element => {
    const { t } = this.props;

    const isNotFavSharedAssetTab = !this.props.isFavAsset && !this.props.isSharedAsset

    return (
      <>
        {isNotFavSharedAssetTab &&
          this.getFavAssetIcon(asset)
        }
        {isNotFavSharedAssetTab && this.props.handleDeleteAsset &&
          this.getSharedAssetIcon(asset)
        }
        {this.props.handleDeleteAsset && isNotFavSharedAssetTab &&
          <MenuItem
            button
            dense={true}
            onClick={() => { this.handleDeleteAsset(asset.wideoId, asset.id) }}
            cyid={"assetUserDialogActionDelete"}
            id="deleteAssetButton"
          >
            <ListItemIcon>
              <Delete fontSize="small" />
            </ListItemIcon>
            <ListItemText primary={t("leftbar.commons.delete")} />
          </MenuItem>
        }
        {this.props.isFavAsset &&
          <MenuItem
            button
            dense={true}
            onClick={() => { this.handleDeleteAsFavAsset(asset.id) }}
            cyid={"favAssetUserDialogActionDelete"}
            id="favDeleteAssetButton"
          >
            <ListItemIcon>
              <Delete fontSize="small" />
            </ListItemIcon>
            <ListItemText primary={t("leftbar.commons.delete-as-fav")} />
          </MenuItem>
        }
      </>
    )

  }

  render() {
    const { t } = this.props;

    const ItemsActions = this.props.assets.map((asset) =>
      <Box key={asset.id}>
        {(this.props.handlePlayAsset && !this.props.isVideoAsset) ? (
          <>
            <Button
              variant="contained"
              size="small"
              color="primary"
              cyclass="assetUserDialogActionUse"
              onClick={() => { this.props.handleOpenAddAudioDialog(asset) }}
            >
              {t("leftbar.commons.use")}
            </Button>
            {!this.props.isSharedAsset && <IconButton
              aria-label="asset sound actions"
              aria-controls="assetSoundActions"
              cyid="assetActionsMenu"
              aria-haspopup="true"
              onClick={this.handleOpenMenu}
              size="small"
              style={styles.dropDownAudios}
            >
              <MoreVertIcon />
            </IconButton>
            }
            <Menu
              id="assetSoundActions"
              cyid="assetActionsPopover"
              anchorEl={this.state.optionsButtonEl}
              open={Boolean(this.state.optionsButtonEl)}
              onClose={this.handleCloseMenu}
            >
              <MenuList>
                {this.getItemsActions(asset)}
              </MenuList>
            </Menu>
          </>
        ) : this.getItemsActions(asset)
        }
      </Box>
    );

    const buttonActionsStyles = (!this.props.handlePlayAsset || this.props.isVideoAsset) ? styles.dropDown : {}

    return (
        <Box 
          component='span'
          sx={buttonActionsStyles}
        >
          {(this.props.handlePlayAsset && !this.props.isVideoAsset) ? (
            ItemsActions
          ) : (
              <>
                {!this.props.isSharedAsset && <IconButton
                  aria-label="asset actions"
                  aria-controls="assetActions"
                  cyid="assetActionsMenu"
                  aria-haspopup="true"
                  onClick={this.handleOpenMenu}
                  size="small"
                >
                  <MoreVertIcon htmlColor="#f5f5f5" />
                </IconButton>
                }
                <Menu
                  id="assetActions"
                  cyid="assetActionsPopover"
                  anchorEl={this.state.optionsButtonEl}
                  open={Boolean(this.state.optionsButtonEl)}
                  onClose={this.handleCloseMenu}
                >
                  <MenuList>
                    {ItemsActions}
                  </MenuList>
                </Menu>
              </>)
          }
        </Box>
    );

  }

}

export default withTranslation("leftbar")(UploadAssetDialogActions);

